import { createAction, handleActions } from "redux-actions";
import TYPE from "../constant/TYPE";

const SET = 'deviceInfo.SET';
const CLEAR = 'deviceInfo.CLEAR';

const defaultState = {
  type : TYPE.DEVICE.PC
};

const setDeviceInfoAction = createAction( SET, payload => payload );
const clearDeviceInfoAction = createAction( CLEAR );

const deviceInfo = handleActions( {
  [ SET ] : ( state, action ) => ( { ...state, ...action.payload } ),
  [ CLEAR ] : () => defaultState
}, defaultState );

export default deviceInfo;
export { setDeviceInfoAction, clearDeviceInfoAction };
